import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../../features/auth/context/AuthContext';
import { SocketProvider } from '../../features/realtime/context/SocketContext';
import { ThemeProvider } from './ThemeProvider';

export default function AppProviders({ children }) {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SocketProvider>
          <BrowserRouter>{children}</BrowserRouter>
        </SocketProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
